import React, { useState, useEffect } from 'react';
import api from '../../api';
import { FaSun, FaSave, FaTrash, FaPlus, FaEdit, FaTimes } from 'react-icons/fa';
import styles from './Admin.module.css';

const AdminPMSuryaghar = () => {
  const [activeTab, setActiveTab] = useState('general');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ text: '', type: '' });
  
  // Data States
  const [data, setData] = useState({
    info: {}, slabs: [], steps: [], netMetering: {}, benefits: []
  });

  // Forms State
  const [slabForm, setSlabForm] = useState({ id: 0, consumptionRange: '', capacity: '', subsidyAmount: '', colorHex: '#4CAF50' });
  const [stepForm, setStepForm] = useState({ id: 0, stepNumber: 1, title: '', description: '', iconName: 'FaFileAlt' });
  const [benefitForm, setBenefitForm] = useState({ id: 0, benefitText: '', category: 'Left' });

 

  useEffect(() => { fetchData(); }, []);

  const fetchData = async () => {
   try {
    // ✅ Updated
    const res = await api.get('/PMScheme');
    setData(res.data);
  } catch (err) {
    console.error("Error loading data", err);
  }
};

  // --- GENERAL ACTIONS ---
  const handleInfoChange = (e) => {
    setData({ ...data, info: { ...data.info, [e.target.name]: e.target.value } });
  };

  const saveInfo = async (e) => {
    e.preventDefault();
    setLoading(true);
  try {
    // ✅ Updated (No token needed manually)
    await api.post('/PMScheme/update-info', data.info);
    setMessage({ text: "Info Updated!", type: "success" });
  } catch (err) { setMessage({ text: "Error updating info", type: "error" }); }
  finally { setLoading(false); }
};

  // --- NET METERING ACTIONS ---
  const handleNetChange = (e) => {
    setData({ ...data, netMetering: { ...data.netMetering, [e.target.name]: e.target.value } });
  };

  const saveNetMetering = async (e) => {
    e.preventDefault();
    setLoading(true);
  try {
    // ✅ Updated
    await api.post('/PMScheme/update-net-metering', data.netMetering);
    setMessage({ text: "Net Metering Updated!", type: "success" });
  } catch (err) { setMessage({ text: "Error updating", type: "error" }); }
  finally { setLoading(false); }
};
  // --- SLAB ACTIONS ---
  const saveSlab = async (e) => {
    e.preventDefault();
   try {
    // ✅ Updated
    await api.post('/PMScheme/save-slab', slabForm);
    fetchData(); 
    setSlabForm({ id: 0, consumptionRange: '', capacity: '', subsidyAmount: '', colorHex: '#4CAF50' });
  } catch (err) { alert("Error saving slab"); }
};

  const deleteSlab = async (id) => {
    if(!window.confirm("Delete Slab?")) return;
   await api.delete(`/PMScheme/delete-slab/${id}`);
    fetchData();
  };

  // --- STEP ACTIONS ---
  const saveStep = async (e) => {
    e.preventDefault();
  try {
    // ✅ Updated
    await api.post('/PMScheme/save-step', stepForm);
    fetchData(); 
    setStepForm({ id: 0, stepNumber: data.steps.length + 1, title: '', description: '', iconName: 'FaFileAlt' });
  } catch (err) { alert("Error saving step"); }
};
  const deleteStep = async (id) => {
    if(!window.confirm("Delete Step?")) return;
   await api.delete(`/PMScheme/delete-step/${id}`);
    fetchData();
  };

  // --- BENEFIT ACTIONS ---
  const saveBenefit = async (e) => {
    e.preventDefault();
   try {
    // ✅ Updated
    await api.post('/PMScheme/save-benefit', benefitForm);
    fetchData(); 
    setBenefitForm({ id: 0, benefitText: '', category: 'Left' });
  } catch (err) { alert("Error saving benefit"); }
};

  const deleteBenefit = async (id) => {
    await api.delete(`/PMScheme/delete-benefit/${id}`);
    fetchData();
  };

  if (!data.info) return <div style={{color:'white'}}>Loading...</div>;

  return (
    <div className={styles.formCard} style={{ maxWidth: '1100px' }}>
      <h3 style={{ marginBottom: '1.5rem', color: '#4ade80' }}><FaSun /> PM Suryaghar Management</h3>

      {/* TABS */}
      <div style={{ display: 'flex', gap: '10px', marginBottom: '20px', borderBottom: '1px solid #444', paddingBottom: '10px', flexWrap:'wrap' }}>
        {['general', 'slabs', 'netMetering', 'steps', 'benefits'].map(tab => (
          <button 
            key={tab} 
            onClick={() => setActiveTab(tab)}
            style={{
              padding: '8px 15px', borderRadius: '5px', border: 'none', cursor: 'pointer', fontWeight: 'bold', textTransform: 'capitalize',
              background: activeTab === tab ? '#4ade80' : 'transparent', color: activeTab === tab ? '#000' : '#888'
            }}
          >
            {tab.replace(/([A-Z])/g, ' $1').trim()}
          </button>
        ))}
      </div>

      {message.text && <div style={{padding:'10px', marginBottom:'20px', background: message.type==='error'?'#ef444433':'#4ade8033', color: message.type==='error'?'#ef4444':'#4ade80', borderRadius:'5px'}}>{message.text}</div>}

      {/* --- TAB 1: GENERAL INFO --- */}
      {activeTab === 'general' && (
        <form onSubmit={saveInfo}>
          <div className={styles.formGroup}><label>Main Title</label><input className={styles.formInput} name="mainTitle" value={data.info.mainTitle} onChange={handleInfoChange} /></div>
          <div className={styles.formGroup}><label>Subtitle</label><input className={styles.formInput} name="subtitle" value={data.info.subtitle} onChange={handleInfoChange} /></div>
          <div className={styles.formGroup}><label>Description</label><textarea className={styles.formInput} name="description" value={data.info.description} onChange={handleInfoChange} rows="3" /></div>
          <div className={styles.formGroup}><label>Highlight Text</label><input className={styles.formInput} name="highlightText" value={data.info.highlightText} onChange={handleInfoChange} /></div>
          <div style={{display:'grid', gridTemplateColumns:'1fr 1fr', gap:'15px'}}>
            <div className={styles.formGroup}><label>GHS Subsidy</label><input className={styles.formInput} name="ghS_Subsidy" value={data.info.ghS_Subsidy} onChange={handleInfoChange} /></div>
            <div className={styles.formGroup}><label>GHS Capacity</label><input className={styles.formInput} name="ghS_Capacity" value={data.info.ghS_Capacity} onChange={handleInfoChange} /></div>
          </div>
          <button className={styles.primaryBtn} disabled={loading}>{loading ? 'Saving...' : <><FaSave /> Save Info</>}</button>
        </form>
      )}

      {/* --- TAB 2: SUBSIDY SLABS --- */}
      {activeTab === 'slabs' && (
        <div>
          <form onSubmit={saveSlab} style={{background:'#ffffff10', padding:'15px', borderRadius:'10px', marginBottom:'20px'}}>
            <h4 style={{color:'white', margin:'0 0 10px'}}>Add/Edit Slab</h4>
            <div style={{display:'grid', gridTemplateColumns:'1fr 1fr 1fr 1fr', gap:'10px'}}>
              <input className={styles.formInput} placeholder="Range (0-150 units)" value={slabForm.consumptionRange} onChange={e=>setSlabForm({...slabForm, consumptionRange:e.target.value})} required />
              <input className={styles.formInput} placeholder="Capacity (1 kW)" value={slabForm.capacity} onChange={e=>setSlabForm({...slabForm, capacity:e.target.value})} required />
              <input className={styles.formInput} placeholder="Amount (₹30,000)" value={slabForm.subsidyAmount} onChange={e=>setSlabForm({...slabForm, subsidyAmount:e.target.value})} required />
              <div style={{display:'flex', gap:'5px'}}><input type="color" value={slabForm.colorHex} onChange={e=>setSlabForm({...slabForm, colorHex:e.target.value})} style={{height:'40px'}} /><button className={styles.primaryBtn}><FaPlus /></button></div>
            </div>
          </form>
          <div style={{display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(200px, 1fr))', gap:'15px'}}>
            {data.slabs.map(slab => (
              <div key={slab.id} style={{borderTop:`4px solid ${slab.colorHex}`, background:'#ffffff05', padding:'15px', borderRadius:'5px'}}>
                <h5 style={{color:'white', margin:0}}>{slab.capacity}</h5>
                <small style={{color:'#888'}}>{slab.consumptionRange}</small>
                <h4 style={{color:slab.colorHex, margin:'5px 0'}}>{slab.subsidyAmount}</h4>
                <div style={{display:'flex', justifyContent:'space-between', marginTop:'10px'}}>
                  <button onClick={()=>setSlabForm(slab)} style={{color:'#4ade80', background:'none', border:'none', cursor:'pointer'}}><FaEdit /></button>
                  <button onClick={()=>deleteSlab(slab.id)} style={{color:'#ef4444', background:'none', border:'none', cursor:'pointer'}}><FaTrash /></button>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* --- TAB 3: NET METERING --- */}
      {activeTab === 'netMetering' && data.netMetering && (
        <form onSubmit={saveNetMetering}>
          <h4 style={{color:'#ff9800', marginBottom:'10px'}}>Case 1 (Solar &lt; Consumption)</h4>
          <div style={{display:'grid', gridTemplateColumns:'1fr 1fr', gap:'10px'}}>
            <div className={styles.formGroup}><label>Title</label><input className={styles.formInput} name="case1_Title" value={data.netMetering.case1_Title} onChange={handleNetChange} /></div>
            <div className={styles.formGroup}><label>Description</label><input className={styles.formInput} name="case1_Desc" value={data.netMetering.case1_Desc} onChange={handleNetChange} /></div>
            <div className={styles.formGroup}><label>Solar Value</label><input className={styles.formInput} name="case1_Solar" value={data.netMetering.case1_Solar} onChange={handleNetChange} /></div>
            <div className={styles.formGroup}><label>Grid Value</label><input className={styles.formInput} name="case1_Grid" value={data.netMetering.case1_Grid} onChange={handleNetChange} /></div>
          </div>

          <h4 style={{color:'#4ade80', margin:'20px 0 10px'}}>Case 2 (Solar &gt; Consumption)</h4>
          <div style={{display:'grid', gridTemplateColumns:'1fr 1fr', gap:'10px'}}>
            <div className={styles.formGroup}><label>Title</label><input className={styles.formInput} name="case2_Title" value={data.netMetering.case2_Title} onChange={handleNetChange} /></div>
            <div className={styles.formGroup}><label>Description</label><input className={styles.formInput} name="case2_Desc" value={data.netMetering.case2_Desc} onChange={handleNetChange} /></div>
            <div className={styles.formGroup}><label>Solar Value</label><input className={styles.formInput} name="case2_Solar" value={data.netMetering.case2_Solar} onChange={handleNetChange} /></div>
            <div className={styles.formGroup}><label>Grid Value</label><input className={styles.formInput} name="case2_Grid" value={data.netMetering.case2_Grid} onChange={handleNetChange} /></div>
          </div>

          <div className={styles.formGroup} style={{marginTop:'15px'}}><label>Footer Text</label><textarea className={styles.formInput} name="footerText" value={data.netMetering.footerText} onChange={handleNetChange} rows="2" /></div>
          <button className={styles.primaryBtn} disabled={loading}>{loading ? 'Saving...' : <><FaSave /> Update Net Metering</>}</button>
        </form>
      )}

      {/* --- TAB 4: STEPS --- */}
      {activeTab === 'steps' && (
        <div>
          <form onSubmit={saveStep} style={{background:'#ffffff10', padding:'15px', borderRadius:'10px', marginBottom:'20px'}}>
            <div style={{display:'grid', gridTemplateColumns:'80px 1fr 1fr 100px', gap:'10px', alignItems:'end'}}>
              <div className={styles.formGroup}><label>No.</label><input className={styles.formInput} type="number" value={stepForm.stepNumber} onChange={e=>setStepForm({...stepForm, stepNumber:e.target.value})} /></div>
              <div className={styles.formGroup}><label>Title</label><input className={styles.formInput} value={stepForm.title} onChange={e=>setStepForm({...stepForm, title:e.target.value})} /></div>
              <div className={styles.formGroup}><label>Description</label><input className={styles.formInput} value={stepForm.description} onChange={e=>setStepForm({...stepForm, description:e.target.value})} /></div>
              <button className={styles.primaryBtn} style={{height:'42px'}}><FaPlus /></button>
            </div>
          </form>
          {data.steps.map(step => (
            <div key={step.id} style={{display:'flex', justifyContent:'space-between', alignItems:'center', background:'#ffffff05', padding:'10px', marginBottom:'5px', borderRadius:'5px'}}>
              <div style={{color:'white'}}><strong>#{step.stepNumber}</strong> {step.title} - <small style={{color:'#888'}}>{step.description}</small></div>
              <div>
                <button onClick={()=>setStepForm(step)} style={{color:'#4ade80', background:'none', border:'none', marginRight:'10px', cursor:'pointer'}}><FaEdit /></button>
                <button onClick={()=>deleteStep(step.id)} style={{color:'#ef4444', background:'none', border:'none', cursor:'pointer'}}><FaTrash /></button>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* --- TAB 5: BENEFITS --- */}
      {activeTab === 'benefits' && (
        <div>
          <form onSubmit={saveBenefit} style={{background:'#ffffff10', padding:'15px', borderRadius:'10px', marginBottom:'20px'}}>
            <div style={{display:'grid', gridTemplateColumns:'1fr 100px 100px', gap:'10px', alignItems:'end'}}>
              <div className={styles.formGroup}><label>Benefit Text</label><input className={styles.formInput} value={benefitForm.benefitText} onChange={e=>setBenefitForm({...benefitForm, benefitText:e.target.value})} /></div>
              <div className={styles.formGroup}><label>Column</label><select className={styles.formInput} value={benefitForm.category} onChange={e=>setBenefitForm({...benefitForm, category:e.target.value})}><option>Left</option><option>Right</option></select></div>
              <button className={styles.primaryBtn} style={{height:'42px'}}><FaPlus /></button>
            </div>
          </form>
          <div style={{display:'grid', gridTemplateColumns:'1fr 1fr', gap:'20px'}}>
            {['Left', 'Right'].map(cat => (
              <div key={cat}>
                <h4 style={{color:'#4ade80'}}>{cat} Column</h4>
                {data.benefits.filter(b => b.category === cat).map(b => (
                  <div key={b.id} style={{display:'flex', justifyContent:'space-between', background:'#ffffff05', padding:'8px', marginBottom:'5px', borderRadius:'5px'}}>
                    <span style={{color:'white'}}>{b.benefitText}</span>
                    <button onClick={()=>deleteBenefit(b.id)} style={{color:'#ef4444', background:'none', border:'none', cursor:'pointer'}}><FaTimes /></button>
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminPMSuryaghar;